// extracted by mini-css-extract-plugin
export default {"NavbarMainContainer":"Navbar_NavbarMainContainer__MAu5V","NavbarRightDiv":"Navbar_NavbarRightDiv__42G1s","sovrennLogo":"Navbar_sovrennLogo__jQhDF"};